export const messages = {
  SHOW_SUCCESS_MESSAGE: "SHOW_SUCCESS_MESSAGE",
  SHOW_ERROR_MESSAGE: "SHOW_ERROR_MESSAGE",
  REMOVE_MESSAGE: "REMOVE_MESSAGE",
};
